export default Object.freeze({

    //licensed features
    CheckList: 'CheckList',
    Quotation: 'Quote',
    Contract: 'Contract',

    //portal licenses
    PartnerPortal: 'PartnerPortal',
    CustomerPortal: 'CustomerPortal',
    
});